import { render } from "./NotificationAlert.vue?vue&type=template&id=3d171aaa"
import script from "./NotificationAlert.vue?vue&type=script&lang=js"
export * from "./NotificationAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__